import {
  CVPSearchParams,
  queryStringStore,
} from "../../../WSUtils/wsQueryStringStore";

export const getQuestionFormToken = () => {
  return queryStringStore.qs[CVPSearchParams.cvptoken]?.toString();
};
